(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1],{

/***/ 2963:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]",
      function () {
        return __webpack_require__(1358);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(260);
/* harmony import */ var components_Blocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4512);
/* harmony import */ var components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1222);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5641);
/* harmony import */ var components_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1382);
/* harmony import */ var _ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3176);
/* harmony import */ var _ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_formatDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1588);











function ArticleTemplate(param) {
    var data = param.data, className = param.className, classNameArticles = param.classNameArticles;
    var ref, ref1;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__/* .GlobalStateContext */ .Pn);
    var flashMessageCleared = state.header.flashMessageCleared;
    if (!(data === null || data === void 0 ? void 0 : data.postBy)) return null;
    var _postBy = data.postBy, id = _postBy.id, title = _postBy.title, date = _postBy.date, acfPostSettings = _postBy.acfPostSettings, acfBlocks = _postBy.acfBlocks;
    var globalBrandTag = acfPostSettings.globalBrandTag, globalCampaignTag = acfPostSettings.globalCampaignTag, // globalCategoriesTag,
    globalPhotographerTag = acfPostSettings.globalPhotographerTag, globalPublicationTag = acfPostSettings.globalPublicationTag, globalStylistTag = acfPostSettings.globalStylistTag;
    var setSidebarItems = [
        {
            label: "Brand",
            data: globalBrandTag
        },
        {
            label: "Campaign",
            data: globalCampaignTag
        },
        // NOTE: If you add this make sure to filter out 'Uncategorized'
        //   {
        //   label: 'Cateogory',
        // data: globalCategoriesTag,
        //   },
        {
            label: "Photographer",
            data: globalPhotographerTag
        },
        {
            label: "Publication",
            data: globalPublicationTag
        },
        {
            label: "Stylist",
            data: globalStylistTag
        }, 
    ];
    var setDate = (0,_helpers_formatDate__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(date));
    var models = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : acfPostSettings.relatedModels;
    var relatedPosts = models === null || models === void 0 ? void 0 : (ref = models[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.relatedPosts) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f) {
        return f.id !== id;
    });
    var setSidebarItem = function(label, data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tag),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().label),
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                }),
                data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().names),
                    children: data.map(function(param) {
                        var name = param.name;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().name),
                            dangerouslySetInnerHTML: {
                                __html: name
                            }
                        }, name);
                    })
                })
            ]
        }, label);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().container), className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: acfBlocks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Blocks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            postType: "Post",
                            children: acfBlocks
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().sidebar),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().sidebarContent),
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Title__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    title: title.substr(0, title.indexOf("|")) || title,
                                    subtitle: title.split("|").length === 2 ? null : title.split("|")[1],
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().title)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tags),
                                    children: [
                                        (models === null || models === void 0 ? void 0 : models.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tag),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().label),
                                                    dangerouslySetInnerHTML: {
                                                        __html: "Models"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().names),
                                                    children: models.map(function(param) {
                                                        var slug = param.slug, title = param.title;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            type: "Model",
                                                            href: slug,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: title
                                                                },
                                                                className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().name)
                                                            })
                                                        }, slug);
                                                    })
                                                })
                                            ]
                                        }),
                                        setSidebarItems === null || setSidebarItems === void 0 ? void 0 : setSidebarItems.map(function(item) {
                                            if (!item || item.data.length < 1) return null;
                                            return setSidebarItem(item.label, item.data);
                                        })
                                    ]
                                }),
                                setDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().date),
                                    children: setDate
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                wrapperClassName: classNameArticles,
                articles: relatedPosts
            })
        ]
    });
}
ArticleTemplate.propTypes = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    classNameArticles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
};
ArticleTemplate.defaultProps = {
    data: {},
    className: "",
    classNameArticles: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleTemplate);


/***/ }),

/***/ 1222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5641);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9305);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__);






function ArticlesRelated(param) {
    var articles = param.articles, className = param.className, wrapperClassName = param.wrapperClassName;
    if (articles === null || articles.length < 1) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().container), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().wrapper), wrapperClassName),
            children: articles.filter(function(f) {
                return f.acfPost.featuredImage !== null;
            }).map(function(param) {
                var slug = param.slug, title = param.title, acfPost = param.acfPost, acfPostSettings = param.acfPostSettings;
                var ref, ref1, ref2;
                var setRelatedModels = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : (ref = acfPostSettings.relatedModels) === null || ref === void 0 ? void 0 : ref.map(function(rm) {
                    return rm.title;
                }).join(", ").replace(/,(?!.*,)/gim, " &");
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: slug,
                    type: "Article",
                    className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().project),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().imgWrap),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                images: [
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref1 = acfPost.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl,
                                        params: "w_510,f_auto"
                                    },
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref2 = acfPost.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl,
                                        params: "w_445,f_auto"
                                    }, 
                                ],
                                className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().img)
                            })
                        }),
                        setRelatedModels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().title),
                            dangerouslySetInnerHTML: {
                                __html: setRelatedModels
                            }
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                            dangerouslySetInnerHTML: {
                                __html: title.substr(0, title.lastIndexOf("|")) || title
                            }
                        })
                    ]
                }, slug);
            })
        })
    });
}
ArticlesRelated.propTypes = {
    articles: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
ArticlesRelated.defaultProps = {
    articles: [],
    className: "",
    wrapperClassName: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlesRelated);


/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9152);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Loading_module_css__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    var initialColours = param.initialColours, hideLinks = param.hideLinks, className = param.className, children = param.children;
    var initialPageColour = initialColours.initialPageColour, initialUiColour = initialColours.initialUiColour;
    var setInitialPageColour = initialPageColour ? initialPageColour : "#fff";
    var setInitialUiColour = initialUiColour ? initialUiColour : "#000";
    // const setInitialTextColour = initialTextColour ? initialTextColour : '#000'
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: "body { background-color: ".concat(initialPageColour, " }\n            #header *,\n            #header-title * {\n              color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }\n            #header *::before,\n            #header *::after,\n            #header-title-line { \n              background-color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), (classnames__WEBPACK_IMPORTED_MODULE_1___default())),
                style: {
                    backgroundColor: setInitialPageColour
                },
                children: children
            })
        ]
    });
}
Loading.propTypes = {
    initialColours: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    hideLinks: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
Loading.defaultProps = {
    initialColours: {},
    hideLinks: false,
    className: "",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 6653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662);
/* harmony import */ var hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(698);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5641);
/* harmony import */ var components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8115);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2657);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7764);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__);












function SliderCover(param) {
    var title = param.title, covers = param.covers, coverTitle = param.coverTitle, noLink = param.noLink, className = param.className;
    var ref;
    if ((covers === null || covers === void 0 ? void 0 : covers.length) < 0) return null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), timeoutId = ref2[0], setTimeoutId = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), locationTimeoutId = ref3[0], setLocationTimeoutId = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), videoTimeoutId = ref4[0], setVideoTimeoutId = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderColour = ref5[0], setSliderColour = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderMobileColour = ref6[0], setSliderMobileColour = ref6[1];
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var setSliderLength = covers.length;
    var windowSize = (0,hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isDesktop = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900;
    var isMobile = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 900;
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(timeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(locationTimeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(videoTimeoutId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var doc = document.documentElement;
        var headerAttr = "data-header-color";
        if (isMobile && (router.pathname === "/[site]/[boardType]" || router.pathname === "/[site]/[boardType]/[boardSlug]") || isMobile && sliderMobileColour === "dark") {
            doc.setAttribute(headerAttr, "dark");
        } else if (isMobile && sliderMobileColour === "light" || isDesktop && sliderColour === "light") {
            doc.setAttribute(headerAttr, "light");
        } else if (isDesktop && sliderColour === "light-dark-logo") {
            doc.setAttribute(headerAttr, "light-ui-dark-logo");
        } else if (isDesktop && sliderColour === "dark-light-logo") {
            doc.setAttribute(headerAttr, "dark-ui-light-logo");
        }
        return function() {
            doc.removeAttribute(headerAttr);
        };
    }, [
        isMobile,
        sliderColour,
        sliderMobileColour
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        //TODO: Quickly added a random timeout to try and play videos
        // after a location change. Need to find a proper way to resolve
        // when time is allocated
        return function() {
            var locationTimeoutId = setTimeout(function() {
                playVideo();
            }, 2000);
            setLocationTimeoutId(locationTimeoutId);
        };
    }, [
        router
    ]);
    var sliderSettings = {
        fade: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        onInit: function() {
            var ref, ref1;
            // NOTE: Arbitrary timeout set here. Can we get the video before slider
            // init as it is firing before?
            var timeoutId = setTimeout(function() {
                playVideo();
            }, 1000);
            setTimeoutId(timeoutId);
            if ((ref = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref === void 0 ? void 0 : (ref1 = ref.covers) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var ref2, ref3;
                var ref4 = (ref2 = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.covers) === null || ref3 === void 0 ? void 0 : ref3[0], uiColour = ref4.uiColour, uiColourMobile = ref4.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        beforeChange: function(oldIndex, newIndex) {
            var ref, ref1, ref2;
            setProgress(newIndex / (setSliderLength - 1) * 100);
            if (covers === null || covers === void 0 ? void 0 : (ref = covers[newIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.acfHighlightCover) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.covers) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var ref3, ref4;
                var ref5 = (ref3 = covers === null || covers === void 0 ? void 0 : covers[newIndex].acfHighlightCover) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.covers) === null || ref4 === void 0 ? void 0 : ref4[0], uiColour = ref5.uiColour, uiColourMobile = ref5.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        afterChange: function(index) {
            playVideo();
        }
    };
    // NOTE: We should really be using refs instead of query selector
    // to acceess videos.
    var getVideo = function(video) {
        if (video) {
            var promiseVideo = video.play();
            if (promiseVideo !== undefined) {
                promiseVideo.catch(function(error) {
                    console.log("video error: ", error);
                }).then(function() {
                    var ref;
                    sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPause();
                });
            }
        }
    };
    var playVideo = function() {
        if (true) {
            var videos = document.querySelectorAll(".slick-slide.slick-active video");
            getVideo(videos[0], !isDesktop);
            getVideo(videos[1], isDesktop);
        }
    };
    var handleVideoEnded = function() {
        var ref, ref1;
        if (true) {
            var videos = document.querySelectorAll(".slick-slide:not(.slick-active) video");
            // SEL-26 - Some how one user that seems to have this blinking page open forever is now killing sentry because videos.forEach() doesn't exist
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(!videos, NodeList)) {
                return;
            }
            var videoTimeoutId = setTimeout(function() {
                videos.forEach(function(video) {
                    video.load();
                });
            }, 1000);
            setVideoTimeoutId(videoTimeoutId);
        }
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPlay();
    };
    var setLink = function(slug, children) {
        var decideLink = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        return !decideLink && !noLink && slug ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            type: "Highlight",
            href: slug,
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
            children: children
        }) : children;
    };
    var decideMedia = function(videos, images, className) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().media), className),
            videos: videos,
            videoAutoplay: false,
            videoEnded: function() {
                return handleVideoEnded();
            },
            images: images,
            noLazy: true
        });
    };
    var setContent = function(videosMobile, videosDesktop, images, title, description) {
        var slug = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", decideLink = arguments.length > 6 ? arguments[6] : void 0, gender = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", modelSlug = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().slide),
            children: [
                setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        videosMobile && decideMedia(videosMobile, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaMobile)),
                        videosDesktop && decideMedia(videosDesktop, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaDesktop))
                    ]
                }), decideLink),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().info),
                    children: [
                        title && modelSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            type: "Model",
                            href: modelSlug,
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().title),
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            })
                        }),
                        description && setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().description),
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }), decideLink)
                    ]
                })
            ]
        }, "".concat(description, "_").concat(title, "_").concat(slug));
    };
    var setVideos = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var mobileType = mobile === null || mobile === void 0 ? void 0 : mobile.mimeType;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        var desktopType = desktop === null || desktop === void 0 ? void 0 : desktop.mimeType;
        return [
            mobileUrl ? {
                url: mobileUrl,
                type: mobileType
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                type: desktopType
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    var setImages = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        return [
            mobileUrl ? {
                url: mobileUrl,
                params: "f_auto"
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                params: "f_auto"
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().container), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitleContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitle),
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                parentRef: sliderRef,
                setKey: (ref = router.query) === null || ref === void 0 ? void 0 : ref.boardSlug,
                settings: sliderSettings,
                children: covers === null || covers === void 0 ? void 0 : covers.map(function(param, i) {
                    var acfBlocks = param.acfBlocks, acfHighlightCover = param.acfHighlightCover, acfHighlightSettings = param.acfHighlightSettings, slug = param.slug;
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    if (!(acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.covers) || (acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : (ref = acfHighlightCover.covers) === null || ref === void 0 ? void 0 : ref.length) < 1) return null;
                    var ref6 = acfHighlightCover.covers[0], videoMobile = ref6.videoMobile, videoMobileWebm = ref6.videoMobileWebm, videoDesktop = ref6.videoDesktop, videoDesktopWebm = ref6.videoDesktopWebm, imageMobile = ref6.imageMobile, imageDesktop = ref6.imageDesktop;
                    var title = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref1 = acfHighlightSettings.models) === null || ref1 === void 0 ? void 0 : ref1.title;
                    var modelSlug = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref2 = acfHighlightSettings.models) === null || ref2 === void 0 ? void 0 : ref2.slug;
                    var description = acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription;
                    var decideLink = ((ref3 = acfBlocks.contentBlocks) === null || ref3 === void 0 ? void 0 : ref3.length) < 1;
                    var gender = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref4 = acfHighlightSettings.models) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.acfModel) === null || ref5 === void 0 ? void 0 : ref5.gender;
                    return setContent(setVideos(videoMobileWebm, videoMobile), setVideos(videoDesktopWebm, videoDesktop), setImages(imageMobile, imageDesktop), title, coverTitle || description, slug, decideLink, gender, title ? modelSlug : null);
                })
            }),
            covers.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBar),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBarIndicator),
                    style: {
                        width: "".concat(progress, "%")
                    }
                })
            })
        ]
    });
}
SliderCover.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    covers: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().array),
    coverTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    noLink: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
SliderCover.defaultProps = {
    title: "",
    covers: [],
    coverTitle: "",
    noLink: false,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderCover);


/***/ }),

/***/ 1062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SplashText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/SplashText/rows.json
var rows_namespaceObject = JSON.parse('[["London","Atlanta","London","Stockholm","London","Paris","London","Chicago","Atlanta","London","Stockholm","London","Paris","London","Chicago","Los Angeles","Atlanta","Stockholm","London","Paris","Milano","London","Atlanta","London","Stockholm","London","Paris","London"],["Chicago","Los Angeles","Milano","Paris","Chicago","Milano","Stockholm","Milano","Los Angeles","Milano","Atlanta","Chicago","Milano","Stockholm","Milano","Los Angeles","Milano","Paris","Chicago","Milano","Stockholm","Chicago","Los Angeles","Milano","Paris","Chicago","Milano","Stockholm"],["Paris","London","Stockholm","London","Los Angeles","London","Miami","Paris","London","Stockholm","Miami","Los Angeles","Chicago","Miami","Paris","London","Stockholm","Miami","Los Angeles","Chicago","Miami","Paris","London","Stockholm","Miami","Los Angeles","Chicago","Miami"],["Los Angeles","Milano","Paris","Chicago","Atlanta","Stockholm","Atlanta","Los Angeles","Milano","Paris","London","Atlanta","Stockholm","Atlanta","Los Angeles","Milano","Paris","London","Atlanta","Stockholm","Los Angeles","Atlanta","Milano","Paris","London","Atlanta","Stockholm","Los Angeles"],["Miami","Chicago","Miami","Milano","Miami","Los Angeles","Milano","Miami","Chicago","Miami","Milano","Miami","Los Angeles","Milano","Miami","Chicago","Miami","Milano","Miami","Los Angeles","Milano","Miami","Chicago","Miami","Milano","Miami","Los Angeles","Milano"],["Stockholm","Paris","London","Stockholm","London","Chicago","Paris","Stockholm","Paris","Los Angeles","Chicago","Paris","London","Paris","Stockholm","Paris","Los Angeles","Atlanta","Paris","London","Paris","Stockholm","Paris","Los Angeles","Atlanta","Paris","London","Paris"],["London","Miami","Atlanta","Miami","Milano","Miami","Milano","London","Miami","Atlanta","Paris","Milano","Miami","Chicago","London","Miami","London","Chicago","Milano","Miami","Chicago","Milano","Miami","Atlanta","Chicago","Milano","Miami","Chicago"],["Atlanta","Stockholm","Chicago","Los Angeles","Stockholm","Atlanta","Chicago","Atlanta","Stockholm","Chicago","Los Angeles","Stockholm","Atlanta","Milano","Atlanta","Stockholm","Chicago","Los Angeles","Stockholm","Atlanta","London","Atlanta","Stockholm","Chicago","Los Angeles","Stockholm","Atlanta","Milano"],["Paris","London","Paris","London","Chicago","London","Miami","Paris","Milano","Paris","London","Paris","Stockholm","Miami","Paris","Milano","Stockholm","London","Paris","Stockholm","Miami","Paris","Milano","Stockholm","London","Paris","Stockholm","Miami"],["Atlanta","Miami","Stockholm","Atlanta","Paris","Stockholm","Atlanta","Stockholm","Miami","Stockholm","Atlanta","Chicago","London","Los Angeles","Stockholm","Miami","Paris","Stockholm","Milano","London","Atlanta","Los Angeles","Miami","Paris","Stockholm","Milano","London","Atlanta"],["Milano","London","Los Angeles","Chicago","Milano","Miami","Los Angeles","Milano","London","Los Angeles","Chicago","Milano","Miami","Stockholm","Atlanta","London","Los Angeles","Chicago","Chicago","Miami","Stockholm","Milano","London","Los Angeles","Chicago","Chicago","Miami","Stockholm"],["Miami","Chicago","Miami","Milano","Los Angeles","Chicago","Stockholm","Miami","Chicago","Miami","Milano","Los Angeles","Chicago","Los Angeles","Miami","Chicago","Miami","Milano","Los Angeles","Chicago","Los Angeles","Miami","Chicago","Miami","Milano","Los Angeles","Chicago","Los Angeles"],["London","Atlanta","London","Paris","Atlanta","Paris","Atlanta","Los Angeles","Atlanta","London","Paris","Atlanta","Paris","Atlanta","Los Angeles","Atlanta","London","Paris","Atlanta","Paris","Atlanta","Los Angeles","Atlanta","London","Paris","Atlanta","Paris","Atlanta"],["Chicago","Paris","Chicago","Miami","Stockholm","Los Angeles","London","Chicago","Paris","Chicago","Miami","Stockholm","Los Angeles","London","Chicago","Los Angeles","Chicago","Miami","Stockholm","Atlanta","London","Chicago","Los Angeles","Chicago","Miami","Stockholm","Atlanta","London"],["Stockholm","Los Angeles","Atlanta","Los Angeles","London","Atlanta","Milano","Atlanta","Los Angeles","Atlanta","Los Angeles","London","Atlanta","Chicago","Miami","Paris","Atlanta","Los Angeles","London","Los Angeles","Chicago","Stockholm","Paris","Atlanta","Los Angeles","London","Los Angeles","Chicago"],["London","Miami","Milano","Paris","Miami","Stockholm","Chicago","London","Stockholm","Milano","Stockholm","Miami","Stockholm","Milano","London","Stockholm","Milano","Atlanta","Miami","Stockholm","Milano","London","Stockholm","Milano","Atlanta","Miami","Stockholm","Milano"],["Milano","Stockholm","Los Angeles","Chicago","Atlanta","London","Atlanta","Milano","Miami","Los Angeles","Chicago","Atlanta","London","Atlanta","Milano","Miami","Los Angeles","Chicago","Atlanta","London","Atlanta","Milano","Miami","Los Angeles","Chicago","Atlanta","London","Atlanta"],["Paris","Atlanta","Paris","London","Los Angeles","Paris","Stockholm","Paris","London","Paris","London","Los Angeles","Paris","Stockholm","Paris","Atlanta","Paris","London","Los Angeles","Paris","Stockholm","Paris","Atlanta","Paris","London","Los Angeles","Paris","Stockholm"],["Miami","London","Miami","Stockholm","Miami","Milano","Miami","Los Angeles","Stockholm","Miami","Stockholm","Miami","Milano","Miami","Milano","London","Atlanta","Stockholm","Miami","Milano","Miami","Los Angeles","London","Atlanta","Stockholm","Miami","Milano","Miami"],["Los Angeles","Chicago","Atlanta","Milano","Paris","Chicago","Paris","London","Atlanta","London","Milano","Paris","Chicago","Paris","Los Angeles","Paris","Miami","Milano","Paris","Chicago","Paris","Stockholm","Paris","Miami","Milano","Paris","Chicago","Paris"],["Stockholm","Paris","Stockholm","Los Angeles","London","Atlanta","Los Angeles","Miami","Chicago","Stockholm","Los Angeles","London","Atlanta","Los Angeles","Stockholm","Chicago","Stockholm","Los Angeles","London","Atlanta","Los Angeles","Miami","Chicago","Stockholm","Los Angeles","London","Atlanta","Los Angeles"],["Chicago","Los Angeles","London","Paris","Milano","Paris","Chicago","Chicago","London","Atlanta","Paris","Milano","Paris","Chicago","Chicago","Los Angeles","London","Paris","Milano","Paris","Chicago","Chicago","Los Angeles","London","Paris","Milano","Paris","Chicago"],["Atlanta","Stockholm","Milano","Atlanta","Chicago","Los Angeles","London","Atlanta","Paris","Milano","Miami","Chicago","Los Angeles","London","Atlanta","Stockholm","Milano","Atlanta","Chicago","Los Angeles","London","Atlanta","Stockholm","Milano","Atlanta","Chicago","Los Angeles","London"],["London","Los Angeles","Chicago","Miami","Stockholm","Miami","Milano","Stockholm","Los Angeles","Chicago","Atlanta","Stockholm","Miami","Milano","Chicago","Los Angeles","Chicago","Miami","Stockholm","Miami","Milano","Chicago","Los Angeles","Chicago","Miami","Stockholm","Miami","Milano"],["Chicago","Milano","Paris","London","Los Angeles","Atlanta","Los Angeles","Chicago","Milano","London","Chicago","Los Angeles","Atlanta","Los Angeles","London","Milano","Paris","London","Los Angeles","Atlanta","Los Angeles","London","Milano","Paris","London","Los Angeles","Atlanta","Los Angeles"],["Stockholm","London","Stockholm","Chicago","Miami","London","Miami","Stockholm","Los Angeles","Paris","Atlanta","Miami","London","Miami","Paris","Miami","Stockholm","Chicago","Miami","London","Miami","Stockholm","Atlanta","Stockholm","Chicago","Miami","London","Miami"],["Los Angeles","Paris","Miami","Los Angeles","Milano","Paris","Milano","Los Angeles","Atlanta","Miami","Los Angeles","Milano","Paris","Stockholm","Milano","Atlanta","London","Los Angeles","Milano","Paris","Stockholm","Milano","London","Miami","Los Angeles","Milano","Paris","Stockholm"],["Miami","Atlanta","London","Atlanta","London","Miami","Stockholm","Miami","Paris","Stockholm","Paris","London","Miami","London","Miami","Paris","Miami","Paris","London","Miami","London","Miami","Paris","Milano","Paris","London","Miami","London"],["Milano","Chicago","Milano","Miami","Stockholm","Chicago","London","Milano","Chicago","Milano","Miami","Stockholm","Chicago","Milano","Stockholm","Chicago","Milano","Atlanta","Stockholm","Chicago","Paris","Los Angeles","Chicago","London","Miami","Stockholm","Chicago","Milano"],["London","Miami","Chicago","Atlanta","Paris","Los Angeles","Atlanta","Paris","Miami","Chicago","London","Paris","Los Angeles","Atlanta","Los Angeles","London","Chicago","Miami","Paris","Los Angeles","Atlanta","London","Miami","Chicago","Atlanta","Paris","Los Angeles","Atlanta"],["Paris","Stockholm","Los Angeles","Milano","Chicago","Stockholm","Chicago","London","Stockholm","Los Angeles","Milano","Chicago","Stockholm","Chicago","Atlanta","Stockholm","Los Angeles","Milano","Chicago","Stockholm","Chicago","Paris","Stockholm","Los Angeles","Milano","Chicago","Stockholm","Chicago"],["Atlanta","Milano","Atlanta","Stockholm","Atlanta","Milano","Paris","Atlanta","Milano","Atlanta","Stockholm","Atlanta","Milano","Paris","London","Milano","Atlanta","Stockholm","Atlanta","Milano","Milano","Atlanta","Milano","Atlanta","Stockholm","Atlanta","Milano","Paris"]]');
// EXTERNAL MODULE: ./components/SplashText/SplashText.module.css
var SplashText_module = __webpack_require__(377);
var SplashText_module_default = /*#__PURE__*/__webpack_require__.n(SplashText_module);
;// CONCATENATED MODULE: ./components/SplashText/index.js






function SplashText(param) {
    var location = param.location, className = param.className;
    if (!location) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((SplashText_module_default()).container, className, (0,_define_property/* default */.Z)({}, (SplashText_module_default()).containerActive, location !== "")),
        children: rows_namespaceObject.map(function(row, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SplashText_module_default()).row,
                children: row.map(function(name, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((SplashText_module_default()).text, (0,_define_property/* default */.Z)({}, (SplashText_module_default()).textActive, name === location)),
                        children: name
                    }, "".concat(name).concat(i));
                })
            }, i);
        })
    });
}
SplashText.propTypes = {
    location: (prop_types_default()).string,
    className: (prop_types_default()).string
};
SplashText.defaultProps = {
    location: "",
    className: ""
};
/* harmony default export */ var components_SplashText = (SplashText);


/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8735);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Title_module_css__WEBPACK_IMPORTED_MODULE_2__);





function Title(param) {
    var title = param.title, subtitle = param.subtitle, swapColour = param.swapColour, lightUi = param.lightUi, borderTitle = param.borderTitle, lightSubtitle = param.lightSubtitle, className = param.className, shrinkSubtitleLength = param.shrinkSubtitleLength;
    if (!title) return null;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().swapColour), swapColour), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightUi), lightUi), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().borderTitle), borderTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightSubtitle), lightSubtitle), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitleLong), shrinkSubtitleLength && subtitle.length > shrinkSubtitleLength)),
                dangerouslySetInnerHTML: {
                    __html: subtitle
                }
            })
        ]
    });
}
Title.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    swapColour: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightUi: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    borderTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    shrinkSubtitleLength: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};
Title.defaultProps = {
    title: "",
    subtitle: "",
    swapColour: false,
    lightUi: false,
    borderTitle: false,
    lightSubtitle: false,
    className: "",
    shrinkSubtitleLength: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * @param {Date} date
 * @param {string} locale
 * @param {} options
 *
 * @return {string}
 */ var formatDate = function(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        dateStyle: "medium"
    };
    // Currently, we only use the GB format, but maybe we should use something better for America? ;-)
    return date.toLocaleDateString(locale, options);
};
/* harmony default export */ __webpack_exports__["Z"] = (formatDate);


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClearTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClearTimeout(id) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(id);
        };
    }, [
        id
    ]);
}


/***/ }),

/***/ 1358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _site_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
;// CONCATENATED MODULE: ./helpers/toTitleCase.js
function toTitleCase(phrase) {
    return phrase.toLowerCase().split(" ").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
}

// EXTERNAL MODULE: ./components/Loading/index.js
var Loading = __webpack_require__(2583);
// EXTERNAL MODULE: ./components/SplashText/index.js + 1 modules
var SplashText = __webpack_require__(1062);
// EXTERNAL MODULE: ./components/WordpressSEO/index.js
var WordpressSEO = __webpack_require__(1610);
// EXTERNAL MODULE: ./components/Layout/index.js + 1 modules
var Layout = __webpack_require__(3825);
// EXTERNAL MODULE: ./components/SliderCover/index.js
var SliderCover = __webpack_require__(6653);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 1 modules
var useLazyQuery = __webpack_require__(138);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var graphql_tag_lib = __webpack_require__(5063);
;// CONCATENATED MODULE: ./graphql/categoryMenu.query.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query CATEGORY_MENU_QUERY {\n    pageBy(uri: "news") {\n      acfNews {\n        categoriesMenu {\n          ... on Category {\n            name\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CATEGORY_MENU_QUERY = (0,graphql_tag_lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var categoryMenu_query = (CATEGORY_MENU_QUERY);

// EXTERNAL MODULE: ./components/Link/index.js + 1 modules
var Link = __webpack_require__(5641);
// EXTERNAL MODULE: ./components/CloudinaryMedia/index.js + 3 modules
var CloudinaryMedia = __webpack_require__(2657);
// EXTERNAL MODULE: ./components/Title/index.js
var Title = __webpack_require__(1382);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./components/ArticleTemplate/index.js
var ArticleTemplate = __webpack_require__(8772);
// EXTERNAL MODULE: ./components/BlocksHomepage/OurWorldBlock/OurWorldBlock.module.css
var OurWorldBlock_module = __webpack_require__(5311);
var OurWorldBlock_module_default = /*#__PURE__*/__webpack_require__.n(OurWorldBlock_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/OurWorldBlock/index.js















function OurWorldBlock(param) {
    var siteName = param.siteName, posts = param.posts, className = param.className;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(null), overlayPost = ref5[0], setOverlayPost = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(categoryMenu_query, {
        context: {
            site: router.query.site
        }
    }), 2), loadCategories = ref6[0], ref7 = ref6[1], catData = ref7.data, catLoading = ref7.loading;
    (0,react.useEffect)(function() {
        loadCategories();
    }, []);
    if (!posts) return null;
    var hasCats = catData === null || catData === void 0 ? void 0 : (ref = catData.pageBy) === null || ref === void 0 ? void 0 : (ref1 = ref.acfNews) === null || ref1 === void 0 ? void 0 : ref1.categoriesMenu;
    var catLength = (hasCats === null || hasCats === void 0 ? void 0 : hasCats.length) + 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasCats && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: ".".concat((OurWorldBlock_module_default()).latestAnimation, " {\n            -webkit-animation: animation-latest").concat(catLength, " ").concat(catLength * 2, "s cubic-bezier(0.23, 1, 0.32, 1.2) infinite;\n            animation: animation-latest").concat(catLength, " ").concat(catLength * 2, "s cubic-bezier(0.23, 1, 0.32, 1.2) infinite;\n            }\n            @-webkit-keyframes animation-latest2{0%{margin-top:-180px}5%{margin-top:-90px}50%{margin-top:-90px}55%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}@keyframes animation-latest2{0%{margin-top:-180px}5%{margin-top:-90px}50%{margin-top:-90px}55%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}\n            @-webkit-keyframes animation-latest3{0%{margin-top:-270px}5%{margin-top:-180px}33%{margin-top:-180px}38%{margin-top:-90px}66%{margin-top:-90px}71%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}@keyframes animation-latest3{0%{margin-top:-270px}5%{margin-top:-180px}33%{margin-top:-180px}38%{margin-top:-90px}66%{margin-top:-90px}71%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}\n            @-webkit-keyframes animation-latest4{0%{margin-top:-360px}5%{margin-top:-270px}25%{margin-top:-270px}30%{margin-top:-180px}50%{margin-top:-180px}55%{margin-top:-90px}75%{margin-top:-90px}80%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}@keyframes animation-latest4{0%{margin-top:-360px}5%{margin-top:-270px}25%{margin-top:-270px}30%{margin-top:-180px}50%{margin-top:-180px}55%{margin-top:-90px}75%{margin-top:-90px}80%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}\n            @-webkit-keyframes animation-latest5{0%{margin-top:-450px}5%{margin-top:-360px}20%{margin-top:-360px}25%{margin-top:-270px}40%{margin-top:-270px}45%{margin-top:-180px}60%{margin-top:-180px}65%{margin-top:-90px}80%{margin-top:-90px}85%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}@keyframes animation-latest5{0%{margin-top:-450px}5%{margin-top:-360px}20%{margin-top:-360px}25%{margin-top:-270px}40%{margin-top:-270px}45%{margin-top:-180px}60%{margin-top:-180px}65%{margin-top:-90px}80%{margin-top:-90px}85%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}\n            @-webkit-keyframes animation-latest6{0%{margin-top:-540px}13%{margin-top:-450px}20%{margin-top:-450px}27%{margin-top:-360px}34%{margin-top:-360px}41%{margin-top:-270px}48%{margin-top:-270px}65%{margin-top:-180px}72%{margin-top:-180px}79%{margin-top:-90px}86%{margin-top:-90px}93%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}@keyframes animation-latest6{0%{margin-top:-540px}13%{margin-top:-450px}20%{margin-top:-450px}27%{margin-top:-360px}34%{margin-top:-360px}41%{margin-top:-270px}48%{margin-top:-270px}65%{margin-top:-180px}72%{margin-top:-180px}79%{margin-top:-90px}86%{margin-top:-90px}93%{margin-top:0}99.99%{margin-top:0}100%{margin-top:-270px}}\n          }")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((OurWorldBlock_module_default()).container, className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OurWorldBlock_module_default()).header,
                        children: [
                            siteName !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                title: "Explore Our World"
                            }),
                            siteName === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                title: "Explore",
                                subtitle: "Our World"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                type: "Page",
                                href: "news",
                                className: (OurWorldBlock_module_default()).latest,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (OurWorldBlock_module_default()).latestAnimation,
                                        children: [
                                            catData === null || catData === void 0 ? void 0 : (ref2 = catData.pageBy) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.acfNews) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.categoriesMenu) === null || ref4 === void 0 ? void 0 : ref4.slice(0, 5).map(function(param) {
                                                var name = param.name;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: name
                                                    }
                                                }, name);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Latest News"
                                            })
                                        ]
                                    }),
                                    "Latest News"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        className: classnames_default()((OurWorldBlock_module_default()).overlay, (0,_define_property/* default */.Z)({}, (OurWorldBlock_module_default()).overlayVisible, overlayPost)),
                        closeClassName: (OurWorldBlock_module_default()).overlayCloseBtn,
                        isShowing: overlayPost !== null,
                        hide: function() {
                            return setOverlayPost(null);
                        },
                        closeBtn: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTemplate/* default */.Z, {
                            className: (OurWorldBlock_module_default()).overlayContent,
                            classNameArticles: (OurWorldBlock_module_default()).overlayArticles,
                            data: {
                                postBy: overlayPost
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OurWorldBlock_module_default()).posts,
                        children: posts.map(function(post) {
                            var ref, ref1, ref2;
                            var slug = post.slug, title = post.title, acfPost = post.acfPost, acfPostSettings = post.acfPostSettings;
                            var url = acfPost === null || acfPost === void 0 ? void 0 : (ref = acfPost.featuredImage) === null || ref === void 0 ? void 0 : ref.mediaItemUrl;
                            var modelTitle = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : (ref1 = acfPostSettings.relatedModels) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.title;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OurWorldBlock_module_default()).postWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (OurWorldBlock_module_default()).overlayBtn,
                                        onClick: function() {
                                            return setOverlayPost(post);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        type: "Article",
                                        href: slug,
                                        className: (OurWorldBlock_module_default()).post,
                                        children: [
                                            url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (OurWorldBlock_module_default()).postImgWrap,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                                                    images: [
                                                        {
                                                            url: url,
                                                            params: "w_684,ar_3:4,c_fill,f_auto"
                                                        }
                                                    ],
                                                    className: (OurWorldBlock_module_default()).postImg
                                                })
                                            }),
                                            modelTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: (OurWorldBlock_module_default()).postTitle,
                                                dangerouslySetInnerHTML: {
                                                    __html: modelTitle
                                                }
                                            }),
                                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (OurWorldBlock_module_default()).postSubtitle,
                                                dangerouslySetInnerHTML: {
                                                    __html: title.substr(0, title.lastIndexOf("|")) || title
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, slug);
                        })
                    })
                ]
            })
        ]
    });
}
OurWorldBlock.propTypes = {
    siteName: (prop_types_default()).string,
    posts: (prop_types_default()).array,
    className: (prop_types_default()).string
};
OurWorldBlock.defaultProps = {
    siteName: "",
    posts: [],
    className: ""
};
/* harmony default export */ var BlocksHomepage_OurWorldBlock = (OurWorldBlock);

// EXTERNAL MODULE: ./components/WordpressLink/index.js
var WordpressLink = __webpack_require__(9954);
// EXTERNAL MODULE: ./components/SliderBlock/index.js
var SliderBlock = __webpack_require__(8115);
// EXTERNAL MODULE: ./components/BlocksHomepage/OurWorldExtendedBlock/OurWorldExtendedBlock.module.css
var OurWorldExtendedBlock_module = __webpack_require__(9499);
var OurWorldExtendedBlock_module_default = /*#__PURE__*/__webpack_require__.n(OurWorldExtendedBlock_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/OurWorldExtendedBlock/index.js







function OurWorldExtendedBlock(param) {
    var posts = param.posts, className = param.className;
    if ((posts === null || posts === void 0 ? void 0 : posts.length) < 1) return null;
    var sliderSettings = {
        fade: true,
        infinite: true,
        swipe: false,
        draggable: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((OurWorldExtendedBlock_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OurWorldExtendedBlock_module_default()).posts,
            children: posts.filter(function(p) {
                return p.link && p.link.slug;
            }).map(function(param, i) {
                var id = param.id, type = param.type, link = param.link, video = param.video, videoWebm = param.videoWebm, images = param.images, title = param.title, subtitle = param.subtitle;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(WordpressLink/* default */.Z, {
                    className: (OurWorldExtendedBlock_module_default()).post,
                    link: link,
                    children: [
                        type === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                            videos: [
                                {
                                    url: videoWebm === null || videoWebm === void 0 ? void 0 : videoWebm.mediaItemUrl,
                                    type: videoWebm === null || videoWebm === void 0 ? void 0 : videoWebm.mimeType
                                },
                                {
                                    url: video === null || video === void 0 ? void 0 : video.mediaItemUrl,
                                    type: video === null || video === void 0 ? void 0 : video.mimeType
                                }, 
                            ],
                            videoLoop: true,
                            className: (OurWorldExtendedBlock_module_default()).media
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderBlock/* default */.Z, {
                            // parentRef={sliderRef[i]}
                            className: (OurWorldExtendedBlock_module_default()).slider,
                            settings: sliderSettings,
                            children: images === null || images === void 0 ? void 0 : images.filter(function(i) {
                                var ref;
                                return (ref = i.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl;
                            }).map(function(param) {
                                var image = param.image, title = param.title;
                                var url = image === null || image === void 0 ? void 0 : image.mediaItemUrl;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                                            images: [
                                                {
                                                    url: url,
                                                    params: "w_1.0,ar_1:1,c_fill,g_north,f_auto"
                                                }, 
                                            ],
                                            className: (OurWorldExtendedBlock_module_default()).media
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (OurWorldExtendedBlock_module_default()).title,
                                            dangerouslySetInnerHTML: {
                                                __html: title
                                            }
                                        })
                                    ]
                                }, url);
                            })
                        }),
                        type === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (OurWorldExtendedBlock_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (OurWorldExtendedBlock_module_default()).subtitle,
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }, "".concat(title, "_").concat(link.slug));
            })
        })
    });
}
OurWorldExtendedBlock.propTypes = {
    posts: (prop_types_default()).array,
    className: (prop_types_default()).string
};
OurWorldExtendedBlock.defaultProps = {
    posts: [],
    className: ""
};
/* harmony default export */ var BlocksHomepage_OurWorldExtendedBlock = (OurWorldExtendedBlock);

// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(8509);
// EXTERNAL MODULE: ./components/BlocksHomepage/InstagramBlock/InstagramBlock.module.css
var InstagramBlock_module = __webpack_require__(6339);
var InstagramBlock_module_default = /*#__PURE__*/__webpack_require__.n(InstagramBlock_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/InstagramBlock/index.js








function InstagramBlock(param) {
    var handle = param.handle, posts = param.posts, className = param.className;
    if (posts === null || (posts === null || posts === void 0 ? void 0 : posts.length) < 1) return null;
    var ref = (0,react.useState)(false), overlayVisible = ref[0], setOverlayVisible = ref[1];
    var handleOpenOverlay = function() {
        setOverlayVisible(true);
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)();
    };
    var handleCloseOverlay = function() {
        setOverlayVisible(false);
        (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
    };
    var setPosts = function(array) {
        return array.filter(function(f) {
            return f.mediaType !== "VIDEO";
        }).slice(0, 9).map(function(param) {
            var url = param.url, id = param.id;
            if (!url) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (InstagramBlock_module_default()).btn,
                onClick: handleOpenOverlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InstagramBlock_module_default()).imgWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (InstagramBlock_module_default()).img,
                        src: url,
                        alt: ""
                    })
                })
            }, "".concat(id, "_").concat(url));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((InstagramBlock_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                className: (InstagramBlock_module_default()).title,
                title: "Instagram",
                subtitle: "Follow us",
                swapColour: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstagramBlock_module_default()).posts,
                children: setPosts(posts)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                isShowing: overlayVisible,
                hide: handleCloseOverlay,
                className: (InstagramBlock_module_default()).overlay,
                closeClassName: (InstagramBlock_module_default()).overlayCloseBtn,
                closeBtn: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InstagramBlock_module_default()).posts,
                        children: setPosts(posts)
                    }),
                    handle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://www.instagram.com/".concat(handle),
                        className: (InstagramBlock_module_default()).overlayLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            "Open in instagram",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "11",
                                height: "10",
                                viewBox: "0 0 11 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M1 1H9.5M9.5 1V10M9.5 1L1.5 9",
                                    stroke: "white",
                                    strokeWidth: "2"
                                })
                            })
                        ]
                    })
                ]
            }),
            handle && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://www.instagram.com/".concat(handle),
                className: (InstagramBlock_module_default()).link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: handle
            })
        ]
    });
}
InstagramBlock.propTypes = {
    handle: (prop_types_default()).string.isRequired,
    posts: (prop_types_default()).array,
    className: (prop_types_default()).string
};
InstagramBlock.defaultProps = {
    handle: "",
    posts: [],
    className: ""
};
/* harmony default export */ var BlocksHomepage_InstagramBlock = (InstagramBlock);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(131);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(6529);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(698);
// EXTERNAL MODULE: ./components/CloudinarySolarnetImage/index.js
var CloudinarySolarnetImage = __webpack_require__(8392);
// EXTERNAL MODULE: ./components/BlocksHomepage/ModelsBlock/ModelsBlock.module.css
var ModelsBlock_module = __webpack_require__(6766);
var ModelsBlock_module_default = /*#__PURE__*/__webpack_require__.n(ModelsBlock_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/ModelsBlock/index.js














function ModelsBlock(param) {
    var womensTitle = param.womensTitle, women = param.women, mensTitle = param.mensTitle, men = param.men, className = param.className;
    var router = (0,next_router.useRouter)();
    var setWomensTitle = womensTitle ? womensTitle.split("\n") : null;
    var setMensTitle = mensTitle ? mensTitle.split("\n") : null;
    var windowSize = (0,useWindowSize/* default */.Z)();
    var ref = (0,react.useState)("women"), gender = ref[0], setGender = ref[1];
    var ref1 = (0,react.useState)(setWomensTitle === null || setWomensTitle === void 0 ? void 0 : setWomensTitle[0]), title = ref1[0], setTitle = ref1[1];
    var ref2 = (0,react.useState)(setWomensTitle === null || setWomensTitle === void 0 ? void 0 : setWomensTitle[1]), subtitle = ref2[0], setSubtitle = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 0.9
    }), 2), ref4 = ref3[0], inView = ref3[1];
    var ref5 = (0,react.useState)(false), playSlider = ref5[0], setPlaySlider = ref5[1];
    (0,react.useEffect)(function() {
        if (inView) {
            setPlaySlider(true);
        } else {
            setPlaySlider(false);
        }
    }, [
        inView
    ]);
    if (!women && !men) return null;
    var handleSlider = function(pause) {
        if (pause) {
            setPlaySlider(false);
        } else {
            setPlaySlider(true);
        }
    };
    var handleFemaleGender = function() {
        setGender("women");
        setTitle(setWomensTitle === null || setWomensTitle === void 0 ? void 0 : setWomensTitle[0]);
        setSubtitle(setWomensTitle === null || setWomensTitle === void 0 ? void 0 : setWomensTitle[1]);
        handleSlider("pause");
    };
    var handleMaleGender = function() {
        setGender("men");
        setTitle(setMensTitle === null || setMensTitle === void 0 ? void 0 : setMensTitle[0]);
        setSubtitle(setMensTitle === null || setMensTitle === void 0 ? void 0 : setMensTitle[1]);
        handleSlider("pause");
    };
    var handleFemaleBoard = function() {
        var ref;
        if (gender === "women" || (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900) return router.push("/".concat((ref = router.query) === null || ref === void 0 ? void 0 : ref.site, "/women"));
    };
    var handleMaleBoard = function() {
        var ref;
        if (gender === "men" || (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900) return router.push("/".concat((ref = router.query) === null || ref === void 0 ? void 0 : ref.site, "/men"));
    };
    var setImage = function(url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinarySolarnetImage/* default */.Z, {
            className: (ModelsBlock_module_default()).img,
            image: [
                {
                    url: url === null || url === void 0 ? void 0 : url.replace("/web_start_picture", "/expanded"),
                    params: "w_286,h_387,ar_3:4,c_fit,g_north,f_auto",
                    alt: ""
                }, 
            ]
        });
    };
    var setPosts = function(posts) {
        if (!posts) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelsBlock_module_default()).posts,
                children: posts.slice(0, 6).map(function(param, i) {
                    var image = param.image, link = param.link;
                    if (link && link.slug) {
                        var ref;
                        var slug = link.slug;
                        var title = link.title;
                        var imageUrl = image === null || image === void 0 ? void 0 : image.mediaItemUrl;
                        var coverUrl = (ref = link.acfModel) === null || ref === void 0 ? void 0 : ref.coverImage;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            type: "Model",
                            href: slug,
                            className: (ModelsBlock_module_default()).model,
                            children: [
                                (imageUrl || coverUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ModelsBlock_module_default()).imgWrap,
                                    children: imageUrl ? setImage(imageUrl) : coverUrl && setImage(coverUrl)
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (ModelsBlock_module_default()).name,
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                })
                            ]
                        }, "".concat(slug).concat(i));
                    }
                })
            })
        });
    };
    var sliderResponsive = {
        device: {
            breakpoint: {
                max: 10000,
                min: 0
            },
            items: 1
        }
    };
    var SliderButtons = function(param) {
        var goToSlide = param.goToSlide;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModelsBlock_module_default()).links,
            children: [
                (women === null || women === void 0 ? void 0 : women.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: classnames_default()((ModelsBlock_module_default()).link, (ModelsBlock_module_default()).linkWomens, (0,_define_property/* default */.Z)({}, (ModelsBlock_module_default()).linkActive, gender === "women")),
                    onClick: handleFemaleBoard,
                    onMouseEnter: function() {
                        handleFemaleGender(), goToSlide(2);
                    },
                    onMouseLeave: function() {
                        return handleSlider();
                    },
                    children: "Womens Board"
                }),
                (men === null || men === void 0 ? void 0 : men.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: classnames_default()((ModelsBlock_module_default()).link, (ModelsBlock_module_default()).linkMens, (0,_define_property/* default */.Z)({}, (ModelsBlock_module_default()).linkActive, gender === "men")),
                    onClick: handleMaleBoard,
                    onMouseEnter: function() {
                        handleMaleGender(), goToSlide(3);
                    },
                    onMouseLeave: function() {
                        return handleSlider();
                    },
                    children: "Mens Board"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref4,
        className: classnames_default()((ModelsBlock_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelsBlock_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    className: (ModelsBlock_module_default()).title,
                    title: title,
                    subtitle: subtitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_multi_carousel["default"], {
                containerClass: (ModelsBlock_module_default()).slider,
                responsive: sliderResponsive,
                arrows: false,
                infinite: true,
                autoPlay: playSlider,
                autoPlaySpeed: 4000,
                draggable: false,
                customTransition: "none",
                ssr: true,
                customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderButtons, {}),
                renderButtonGroupOutside: true,
                beforeChange: function(nextSlide, param) {
                    var currentSlide = param.currentSlide;
                    setGender(currentSlide === 2 ? "men" : "women");
                },
                children: [
                    setPosts(women),
                    setPosts(men)
                ]
            })
        ]
    });
}
ModelsBlock.propTypes = {
    womensTitle: (prop_types_default()).string,
    women: (prop_types_default()).array,
    mensTitle: (prop_types_default()).string,
    men: (prop_types_default()).array,
    className: (prop_types_default()).string
};
ModelsBlock.defaultProps = {
    womensTitle: "",
    women: [],
    mensTitle: "",
    men: [],
    className: ""
};
/* harmony default export */ var BlocksHomepage_ModelsBlock = (ModelsBlock);

// EXTERNAL MODULE: ./components/BlocksHomepage/CombinedModelsBlock/CombinedModelsBlock.module.css
var CombinedModelsBlock_module = __webpack_require__(6889);
var CombinedModelsBlock_module_default = /*#__PURE__*/__webpack_require__.n(CombinedModelsBlock_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/CombinedModelsBlock/index.js













function CombinedModelsBlock(param) {
    var title = param.title, models = param.models, className = param.className;
    var router = (0,next_router.useRouter)();
    var titleParts = title.split("\n").filter(function(part) {
        return part !== "";
    });
    var mainTitle = titleParts[0];
    var subTitle = titleParts[1];
    var windowSize = (0,useWindowSize/* default */.Z)();
    var ref = (0,react.useState)("women"), gender = ref[0], setGender = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 0.9
    }), 2), ref2 = ref1[0], inView = ref1[1];
    var ref3 = (0,react.useState)(false), playSlider = ref3[0], setPlaySlider = ref3[1];
    (0,react.useEffect)(function() {
        if (inView) {
            setPlaySlider(true);
        } else {
            setPlaySlider(false);
        }
    }, [
        inView
    ]);
    if (!models) return null;
    var setImage = function(url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinarySolarnetImage/* default */.Z, {
            className: (CombinedModelsBlock_module_default()).img,
            image: [
                {
                    url: url === null || url === void 0 ? void 0 : url.replace("/web_start_picture", "/expanded"),
                    params: "w_286,h_387,ar_3:4,c_fit,g_north,f_auto",
                    alt: ""
                }, 
            ]
        });
    };
    var setPosts = function(posts) {
        if (!posts) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CombinedModelsBlock_module_default()).posts,
                children: posts.slice(0, 6).map(function(param, i) {
                    var image = param.image, link = param.link;
                    if (link && link.slug) {
                        var ref;
                        var slug = link.slug;
                        var title = link.title;
                        var imageUrl = image === null || image === void 0 ? void 0 : image.mediaItemUrl;
                        var coverUrl = (ref = link.acfModel) === null || ref === void 0 ? void 0 : ref.coverImage;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            type: "Model",
                            href: slug,
                            className: (CombinedModelsBlock_module_default()).model,
                            children: [
                                (imageUrl || coverUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CombinedModelsBlock_module_default()).imgWrap,
                                    children: imageUrl ? setImage(imageUrl) : coverUrl && setImage(coverUrl)
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (CombinedModelsBlock_module_default()).name,
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                })
                            ]
                        }, "".concat(slug).concat(i));
                    }
                })
            })
        });
    };
    var sliderResponsive = {
        device: {
            breakpoint: {
                max: 10000,
                min: 0
            },
            items: 1
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref2,
        className: classnames_default()((CombinedModelsBlock_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CombinedModelsBlock_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    className: (CombinedModelsBlock_module_default()).title,
                    title: mainTitle,
                    subtitle: subTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                containerClass: (CombinedModelsBlock_module_default()).slider,
                responsive: sliderResponsive,
                arrows: false,
                infinite: true,
                autoPlay: playSlider,
                autoPlaySpeed: 4000,
                draggable: false,
                customTransition: "none",
                ssr: true,
                renderButtonGroupOutside: true,
                beforeChange: function(nextSlide, param) {
                    var currentSlide = param.currentSlide;
                    setGender(currentSlide === 2 ? "men" : "women");
                },
                children: setPosts(models)
            })
        ]
    });
}
CombinedModelsBlock.propTypes = {
    title: (prop_types_default()).string.isRequired,
    models: prop_types_default().arrayOf((prop_types_default()).object).isRequired,
    className: (prop_types_default()).string
};
CombinedModelsBlock.defaultProps = {
    className: ""
};
/* harmony default export */ var BlocksHomepage_CombinedModelsBlock = (CombinedModelsBlock);

// EXTERNAL MODULE: ./components/BecomeAModel/BecomeAModel.module.css
var BecomeAModel_module = __webpack_require__(7023);
var BecomeAModel_module_default = /*#__PURE__*/__webpack_require__.n(BecomeAModel_module);
;// CONCATENATED MODULE: ./components/BecomeAModel/index.js










function BecomeAModel(param) {
    var promo = param.promo, className = param.className;
    var ref;
    if (((ref = promo.images) === null || ref === void 0 ? void 0 : ref.length) < 1) return null;
    var sliderRef = (0,react.useRef)(null);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 0.9
    }), 2), ref2 = ref1[0], inView = ref1[1];
    (0,react.useEffect)(function() {
        var slider = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current;
        if (slider) {
            if (inView) {
                slider.slickNext();
                slider.slickPlay();
            } else {
                slider.slickPause();
            }
        }
    });
    var images = promo.images, title = promo.title, description = promo.description, link = promo.link;
    var setTitle = title ? title.split("\n") : null;
    var sliderSettings = {
        fade: true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref2,
        className: classnames_default()((BecomeAModel_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (BecomeAModel_module_default()).wrapper,
            children: [
                images && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderBlock/* default */.Z, {
                    parentRef: sliderRef,
                    className: (BecomeAModel_module_default()).slider,
                    settings: sliderSettings,
                    children: images.map(function(param) {
                        var image = param.image;
                        var url = image === null || image === void 0 ? void 0 : image.mediaItemUrl;
                        if (url) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                                    className: (BecomeAModel_module_default()).img,
                                    images: [
                                        {
                                            url: url,
                                            params: "f_auto"
                                        }
                                    ]
                                })
                            }, url);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BecomeAModel_module_default()).infoWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BecomeAModel_module_default()).info,
                        children: [
                            setTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                className: (BecomeAModel_module_default()).title,
                                title: setTitle[0],
                                subtitle: setTitle[1] || null,
                                borderTitle: true,
                                lightSubtitle: true
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (BecomeAModel_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: link.url,
                                className: (BecomeAModel_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: link.title || "Apply to become a model"
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
}
BecomeAModel.propTypes = {
    promo: (prop_types_default()).object,
    className: (prop_types_default()).string
};
BecomeAModel.defaultProps = {
    promo: {},
    className: ""
};
/* harmony default export */ var components_BecomeAModel = (BecomeAModel);

// EXTERNAL MODULE: ./pages/[site]/index.module.css
var index_module = __webpack_require__(1331);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./context/SitesContextProvider.js
var SitesContextProvider = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/underscore/modules/index-all.js + 160 modules
var index_all = __webpack_require__(6005);
// EXTERNAL MODULE: ./components/BlocksHomepage/SeoText/SeoText.module.css
var SeoText_module = __webpack_require__(6929);
var SeoText_module_default = /*#__PURE__*/__webpack_require__.n(SeoText_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/SeoText/index.js




function SeoText(param) {
    var text = param.text;
    if ((0,index_all/* isUndefined */.o8)(text) || (0,index_all/* isNull */.Ft)(text) || text === "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SeoText_module_default()).container,
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}
SeoText.propTypes = {
    text: (prop_types_default()).string
};
SeoText.defaultProps = {
    text: undefined
};
/* harmony default export */ var BlocksHomepage_SeoText = (SeoText);

// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(1876);
// EXTERNAL MODULE: ./components/BlocksHomepage/SeoFaqs/SeoFaqs.module.css
var SeoFaqs_module = __webpack_require__(1399);
var SeoFaqs_module_default = /*#__PURE__*/__webpack_require__.n(SeoFaqs_module);
;// CONCATENATED MODULE: ./components/BlocksHomepage/SeoFaqs/index.js





function SeoFaqs(param) {
    var faqs = param.faqs;
    if ((0,index_all/* isUndefined */.o8)(faqs) || (0,index_all/* isNull */.Ft)(faqs) || faqs.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SeoFaqs_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "FAQs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                allowZeroExpanded: true,
                allowMultipleExpanded: false,
                className: (SeoFaqs_module_default()).accordion,
                children: faqs.map(function(param, i) {
                    var question = param.question, answer = param.answer;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                        className: (SeoFaqs_module_default()).accordion__item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                    className: (SeoFaqs_module_default()).accordion__button,
                                    children: question
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                                className: (SeoFaqs_module_default()).accordion__panel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: answer
                                    }
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
}
SeoFaqs.propTypes = {
    faqs: prop_types_default().arrayOf(prop_types_default().shape({
        question: (prop_types_default()).string.isRequired,
        answer: (prop_types_default()).string.isRequired
    }))
};
SeoFaqs.defaultProps = {
    faqs: []
};
/* harmony default export */ var BlocksHomepage_SeoFaqs = (SeoFaqs);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/[site]/index.js
/* provided dependency */ var process = __webpack_require__(3454);





















// TODO: setup proptypes
function Index(param) {
    var title = param.title, seo = param.seo, site = param.site, acfHomepage = param.acfHomepage, acfSeoAddress = param.acfSeoAddress, instagrams = param.instagrams, ourWorldLatestPosts = param.ourWorldLatestPosts, globalSettings = param.globalSettings;
    var ref, ref1, ref2, ref3;
    var sites = (0,react.useContext)(SitesContextProvider/* SitesContext */.y).sites;
    var isSingleSite = typeof sites !== "undefined" && sites.length === 1;
    var ref4 = (0,react.useState)(false), locationsSplash = ref4[0], setLoading = ref4[1];
    var globalUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://selectmodel.com";
    var siteUrl = "".concat(globalUrl, "/").concat(site);
    (0,react.useEffect)(function() {
        setLoading(true);
        var loadingTimer = setTimeout(function() {
            return setLoading(false);
        }, 1000 * 1.7);
        return function() {
            return clearTimeout(loadingTimer);
        };
    }, [
        site
    ]);
    var siteName = (0,react.useMemo)(function() {
        if (site === "modellink") return "";
        if (!sites) return "";
        var siteObj = sites.find(function(s) {
            return s.path === "/".concat(site, "/");
        });
        return siteObj ? siteObj.name : "";
    }, [
        sites,
        site
    ]);
    if (locationsSplash) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                    url: "/".concat(site),
                    title: title,
                    seo: seo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                    children: !isSingleSite && locationsSplash && /*#__PURE__*/ (0,jsx_runtime.jsx)(SplashText/* default */.Z, {
                        location: toTitleCase(site.replace("-", " "))
                    })
                })
            ]
        });
    }
    var highlightOrder = acfHomepage.highlightOrder, seoH1 = acfHomepage.seoH1, seoText = acfHomepage.seoText, seoFaqs = acfHomepage.seoFaqs, exploreOurWorld = acfHomepage.exploreOurWorld, exploreOurWorldPosts = acfHomepage.exploreOurWorldPosts, exploreOurWorldExtended = acfHomepage.exploreOurWorldExtended, modelsInFocusTitle = acfHomepage.modelsInFocusTitle, modelsInFocus = acfHomepage.modelsInFocus, modelsInFocusWomensTitle = acfHomepage.modelsInFocusWomensTitle, modelsInFocusWomens = acfHomepage.modelsInFocusWomens, modelsInFocusMensTitle = acfHomepage.modelsInFocusMensTitle, modelsInFocusMens = acfHomepage.modelsInFocusMens, promo = acfHomepage.promo;
    var highlightCovers = highlightOrder ? highlightOrder.map(function(c) {
        return c;
    }) : [];
    var igHandle = (globalSettings === null || globalSettings === void 0 ? void 0 : (ref = globalSettings.offices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.acfOffices) === null || ref3 === void 0 ? void 0 : ref3.instagramHandle) || "";
    var lazyLoad = function(children) {
        if (!children) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
            height: 350,
            once: true,
            children: children
        });
    };
    var logoName = site === "modellink" ? "modellink.svg" : "selectmodel.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                url: "/".concat(site),
                title: title,
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, {
                type: "LocalBusiness",
                id: siteUrl,
                url: siteUrl,
                images: [
                    "".concat(globalUrl, "/img/logo/").concat(logoName)
                ],
                name: title,
                description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
                address: {
                    streetAddress: acfSeoAddress === null || acfSeoAddress === void 0 ? void 0 : acfSeoAddress.streetAddress,
                    addressLocality: acfSeoAddress === null || acfSeoAddress === void 0 ? void 0 : acfSeoAddress.addressLocality,
                    addressRegion: acfSeoAddress === null || acfSeoAddress === void 0 ? void 0 : acfSeoAddress.addressRegion,
                    postalCode: acfSeoAddress === null || acfSeoAddress === void 0 ? void 0 : acfSeoAddress.postalCode,
                    addressCountry: acfSeoAddress === null || acfSeoAddress === void 0 ? void 0 : acfSeoAddress.addressCountry
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderCover/* default */.Z, {
                title: seoH1 !== null ? seoH1 : undefined,
                covers: highlightCovers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).container,
                children: [
                    lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_OurWorldBlock, {
                        siteName: siteName,
                        posts: exploreOurWorld === "latest-posts" && (ourWorldLatestPosts === null || ourWorldLatestPosts === void 0 ? void 0 : ourWorldLatestPosts.nodes) ? ourWorldLatestPosts.nodes : exploreOurWorldPosts
                    })),
                    lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_SeoText, {
                        text: seoText
                    })),
                    lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_OurWorldExtendedBlock, {
                        posts: exploreOurWorldExtended
                    })),
                    lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_InstagramBlock, {
                        handle: igHandle,
                        posts: instagrams
                    })),
                    modelsInFocus && modelsInFocus.length > 0 ? lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_CombinedModelsBlock, {
                        title: modelsInFocusTitle,
                        models: modelsInFocus
                    })) : lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_ModelsBlock, {
                        womensTitle: modelsInFocusWomensTitle,
                        women: modelsInFocusWomens,
                        mensTitle: modelsInFocusMensTitle,
                        men: modelsInFocusMens
                    }))
                ]
            }),
            site !== "modellink" && lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_BecomeAModel, {
                promo: promo
            })),
            seoFaqs && seoFaqs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).container,
                children: lazyLoad(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlocksHomepage_SeoFaqs, {
                    faqs: seoFaqs
                }))
            })
        ]
    });
}
Index.propTypes = {
    pageUrl: (prop_types_default()).string,
    pageTitle: (prop_types_default()).string,
    pageDesc: (prop_types_default()).string,
    globalSettings: (prop_types_default()).object
};
Index.defaultProps = {
    pageUrl: "",
    pageTitle: "",
    pageDesc: "",
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ var _site_ = (Index);


/***/ }),

/***/ 3176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticleTemplate_spacing--xxxs__hgHVr","spacing--xxs":"ArticleTemplate_spacing--xxs__zelcf","spacing--xs":"ArticleTemplate_spacing--xs__HldPz","spacing--sm":"ArticleTemplate_spacing--sm__hKOUH","spacing--md":"ArticleTemplate_spacing--md__JfD_P","spacing--lg":"ArticleTemplate_spacing--lg__Y6xV6","spacing--xl":"ArticleTemplate_spacing--xl__jIkdc","spacing--xxl":"ArticleTemplate_spacing--xxl__GFAvL","spacing--xxxl":"ArticleTemplate_spacing--xxxl___Hy9_","container":"ArticleTemplate_container__Q1iYP","wrapper":"ArticleTemplate_wrapper__LJjdZ","sidebar":"ArticleTemplate_sidebar__40vNK","sidebarContent":"ArticleTemplate_sidebarContent__GVndq","title":"ArticleTemplate_title__nUACh","model":"ArticleTemplate_model__ukw_f","date":"ArticleTemplate_date__Wi_TE","tags":"ArticleTemplate_tags__u_RYl","tag":"ArticleTemplate_tag__sBo4f","label":"ArticleTemplate_label__oqQgK","name":"ArticleTemplate_name__oD7X_","names":"ArticleTemplate_names__UM_YS","fadeInItems":"ArticleTemplate_fadeInItems__MHg7t"};

/***/ }),

/***/ 9305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticlesRelated_spacing--xxxs__HwmnX","spacing--xxs":"ArticlesRelated_spacing--xxs___LKEs","spacing--xs":"ArticlesRelated_spacing--xs__5lJr5","spacing--sm":"ArticlesRelated_spacing--sm__bOnZw","spacing--md":"ArticlesRelated_spacing--md__H8nvn","spacing--lg":"ArticlesRelated_spacing--lg__NbATD","spacing--xl":"ArticlesRelated_spacing--xl__paO_V","spacing--xxl":"ArticlesRelated_spacing--xxl__mFWiY","spacing--xxxl":"ArticlesRelated_spacing--xxxl__ddWi4","container":"ArticlesRelated_container__TKTXC","wrapper":"ArticlesRelated_wrapper__o2xSe","project":"ArticlesRelated_project__4ZyZ5","imgWrap":"ArticlesRelated_imgWrap__DBe88","img":"ArticlesRelated_img__hlfxd","title":"ArticlesRelated_title__OLP1_","subtitle":"ArticlesRelated_subtitle__e4AxV","fadeInItems":"ArticlesRelated_fadeInItems__Oveg4"};

/***/ }),

/***/ 7023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BecomeAModel_spacing--xxxs__ETrh_","spacing--xxs":"BecomeAModel_spacing--xxs__mXfdQ","spacing--xs":"BecomeAModel_spacing--xs__vdjww","spacing--sm":"BecomeAModel_spacing--sm__8rdS3","spacing--md":"BecomeAModel_spacing--md__jDVBS","spacing--lg":"BecomeAModel_spacing--lg__VAjAb","spacing--xl":"BecomeAModel_spacing--xl__UIGBY","spacing--xxl":"BecomeAModel_spacing--xxl__LsJuZ","spacing--xxxl":"BecomeAModel_spacing--xxxl__gL6zo","container":"BecomeAModel_container__C3hb2","wrapper":"BecomeAModel_wrapper__FDoM0","slider":"BecomeAModel_slider__GtZHa","img":"BecomeAModel_img__qgfXn","infoWrapper":"BecomeAModel_infoWrapper__k7F7B","info":"BecomeAModel_info__B70N_","title":"BecomeAModel_title__ACfYu","description":"BecomeAModel_description__iCcY2","link":"BecomeAModel_link__oA40M","fadeInItems":"BecomeAModel_fadeInItems__tenvp"};

/***/ }),

/***/ 6889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CombinedModelsBlock_spacing--xxxs__zn10I","spacing--xxs":"CombinedModelsBlock_spacing--xxs__gPl8i","spacing--xs":"CombinedModelsBlock_spacing--xs__nVa6v","spacing--sm":"CombinedModelsBlock_spacing--sm__Y_yay","spacing--md":"CombinedModelsBlock_spacing--md___7rQk","spacing--lg":"CombinedModelsBlock_spacing--lg__X_Ma7","spacing--xl":"CombinedModelsBlock_spacing--xl__R3B7_","spacing--xxl":"CombinedModelsBlock_spacing--xxl__QFRJQ","spacing--xxxl":"CombinedModelsBlock_spacing--xxxl__F_xxW","container":"CombinedModelsBlock_container__cIuKz","title":"CombinedModelsBlock_title__wI_ld","links":"CombinedModelsBlock_links__ccIEI","slider":"CombinedModelsBlock_slider__zNTka","header":"CombinedModelsBlock_header__uPweq","link":"CombinedModelsBlock_link__TeSe_","linkActive":"CombinedModelsBlock_linkActive__7EebE","linkWomens":"CombinedModelsBlock_linkWomens__xIpg0","linkMens":"CombinedModelsBlock_linkMens__jGwZg","posts":"CombinedModelsBlock_posts__NYmX0","model":"CombinedModelsBlock_model__OdZA_","imgWrap":"CombinedModelsBlock_imgWrap__ieVw9","img":"CombinedModelsBlock_img__kaPEh","name":"CombinedModelsBlock_name__gVhel","fadeInItems":"CombinedModelsBlock_fadeInItems__SHQXB"};

/***/ }),

/***/ 6339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"InstagramBlock_spacing--xxxs__yNKDU","spacing--xxs":"InstagramBlock_spacing--xxs__rCidS","spacing--xs":"InstagramBlock_spacing--xs__4oqdF","spacing--sm":"InstagramBlock_spacing--sm__hSUpf","spacing--md":"InstagramBlock_spacing--md__MYqU8","spacing--lg":"InstagramBlock_spacing--lg__Xh0Ff","spacing--xl":"InstagramBlock_spacing--xl__MGRTy","spacing--xxl":"InstagramBlock_spacing--xxl__b7HOv","spacing--xxxl":"InstagramBlock_spacing--xxxl__jjmd_","container":"InstagramBlock_container__LDefE","title":"InstagramBlock_title__prXip","posts":"InstagramBlock_posts__zXKWj","postsMobile":"InstagramBlock_postsMobile__Rde4X","btn":"InstagramBlock_btn__KT_SI","imgWrapper":"InstagramBlock_imgWrapper__WXsTh","img":"InstagramBlock_img__Xajq2","link":"InstagramBlock_link__bXwH8","slider":"InstagramBlock_slider__Y5IxY","overlay":"InstagramBlock_overlay__KuDvv","overlayCloseBtn":"InstagramBlock_overlayCloseBtn__qOp75","overlayLink":"InstagramBlock_overlayLink__RHFgG","fadeInItems":"InstagramBlock_fadeInItems__sq59f"};

/***/ }),

/***/ 6766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ModelsBlock_spacing--xxxs__sQw1z","spacing--xxs":"ModelsBlock_spacing--xxs__DNXY3","spacing--xs":"ModelsBlock_spacing--xs__GdLmY","spacing--sm":"ModelsBlock_spacing--sm__OqrNn","spacing--md":"ModelsBlock_spacing--md__9Ut12","spacing--lg":"ModelsBlock_spacing--lg__cGGuk","spacing--xl":"ModelsBlock_spacing--xl__bbDBf","spacing--xxl":"ModelsBlock_spacing--xxl__tj_R3","spacing--xxxl":"ModelsBlock_spacing--xxxl__dGJWD","container":"ModelsBlock_container__1cCnO","title":"ModelsBlock_title__uym9k","links":"ModelsBlock_links__T0XWw","slider":"ModelsBlock_slider__scX8q","header":"ModelsBlock_header__z4FsL","link":"ModelsBlock_link__k07hd","linkActive":"ModelsBlock_linkActive__YUX3Z","linkWomens":"ModelsBlock_linkWomens__9WEAD","linkMens":"ModelsBlock_linkMens__C5XEj","posts":"ModelsBlock_posts__vYLRj","model":"ModelsBlock_model__sYdXP","imgWrap":"ModelsBlock_imgWrap__4mXeX","img":"ModelsBlock_img__xBE7_","name":"ModelsBlock_name__jVv4B","fadeInItems":"ModelsBlock_fadeInItems__fnAMN"};

/***/ }),

/***/ 5311:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OurWorldBlock_spacing--xxxs__2UNWH","spacing--xxs":"OurWorldBlock_spacing--xxs__nym4n","spacing--xs":"OurWorldBlock_spacing--xs__fKPNX","spacing--sm":"OurWorldBlock_spacing--sm__k6EGT","spacing--md":"OurWorldBlock_spacing--md__S9b2y","spacing--lg":"OurWorldBlock_spacing--lg__S0xr5","spacing--xl":"OurWorldBlock_spacing--xl__kQnKQ","spacing--xxl":"OurWorldBlock_spacing--xxl__jQ74W","spacing--xxxl":"OurWorldBlock_spacing--xxxl__qjqfW","container":"OurWorldBlock_container__VwGJ5","noTitle":"OurWorldBlock_noTitle__sexrX","header":"OurWorldBlock_header__EG4LN","latest":"OurWorldBlock_latest__eKPpS","latestAnimation":"OurWorldBlock_latestAnimation__U204c","posts":"OurWorldBlock_posts__VxqDk","postWrap":"OurWorldBlock_postWrap__Zf0UN","post":"OurWorldBlock_post__cpZ2Y","postImgWrap":"OurWorldBlock_postImgWrap__Z_qKX","postImg":"OurWorldBlock_postImg__J_WdE","postTitle":"OurWorldBlock_postTitle__6wwQh","postSubtitle":"OurWorldBlock_postSubtitle__5iEBA","overlayBtn":"OurWorldBlock_overlayBtn__lEKsq","overlay":"OurWorldBlock_overlay__7H64D","overlayVisible":"OurWorldBlock_overlayVisible__wli4U","overlayCloseBtn":"OurWorldBlock_overlayCloseBtn__aI8AI","overlayContent":"OurWorldBlock_overlayContent__LN_O5","overlayArticles":"OurWorldBlock_overlayArticles__p6JmL","fadeInItems":"OurWorldBlock_fadeInItems__7H_Vp"};

/***/ }),

/***/ 9499:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OurWorldExtendedBlock_spacing--xxxs__GBcFk","spacing--xxs":"OurWorldExtendedBlock_spacing--xxs__gy_c9","spacing--xs":"OurWorldExtendedBlock_spacing--xs__hzxG_","spacing--sm":"OurWorldExtendedBlock_spacing--sm__5k_k7","spacing--md":"OurWorldExtendedBlock_spacing--md__gkWOp","spacing--lg":"OurWorldExtendedBlock_spacing--lg__lYOEe","spacing--xl":"OurWorldExtendedBlock_spacing--xl__rPa2Q","spacing--xxl":"OurWorldExtendedBlock_spacing--xxl__vNsCU","spacing--xxxl":"OurWorldExtendedBlock_spacing--xxxl__UrsVI","container":"OurWorldExtendedBlock_container___9lg0","posts":"OurWorldExtendedBlock_posts__pOGKp","post":"OurWorldExtendedBlock_post__3SGgJ","media":"OurWorldExtendedBlock_media__R1INK","title":"OurWorldExtendedBlock_title__95JRz","subtitle":"OurWorldExtendedBlock_subtitle__0SZZX","fadeInItems":"OurWorldExtendedBlock_fadeInItems__hB8RX"};

/***/ }),

/***/ 1399:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SeoFaqs_spacing--xxxs__VfhRf","spacing--xxs":"SeoFaqs_spacing--xxs__QOrng","spacing--xs":"SeoFaqs_spacing--xs__Lx_4h","spacing--sm":"SeoFaqs_spacing--sm__86c1E","spacing--md":"SeoFaqs_spacing--md__Z3Qdg","spacing--lg":"SeoFaqs_spacing--lg__EkaZA","spacing--xl":"SeoFaqs_spacing--xl__24xUG","spacing--xxl":"SeoFaqs_spacing--xxl__hbf3f","spacing--xxxl":"SeoFaqs_spacing--xxxl__gwRcf","container":"SeoFaqs_container__RGH4z","accordion":"SeoFaqs_accordion__VAKi_","accordion__item":"SeoFaqs_accordion__item__GJRlj","accordion__button":"SeoFaqs_accordion__button__p9yLl","accordion__panel":"SeoFaqs_accordion__panel__OI0ob","fadein":"SeoFaqs_fadein__By1DL","fadeInItems":"SeoFaqs_fadeInItems__A_L_h"};

/***/ }),

/***/ 6929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SeoText_spacing--xxxs__mBkwI","spacing--xxs":"SeoText_spacing--xxs__ZnjVO","spacing--xs":"SeoText_spacing--xs__FvLlB","spacing--sm":"SeoText_spacing--sm__9lpdv","spacing--md":"SeoText_spacing--md__iaJ1o","spacing--lg":"SeoText_spacing--lg__UwMms","spacing--xl":"SeoText_spacing--xl__nHB3K","spacing--xxl":"SeoText_spacing--xxl__zHY4P","spacing--xxxl":"SeoText_spacing--xxxl__m1oYN","container":"SeoText_container__So3yH","fadeInItems":"SeoText_fadeInItems__5Vc_1"};

/***/ }),

/***/ 9152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Loading_spacing--xxxs__mrBZx","spacing--xxs":"Loading_spacing--xxs__gJPeb","spacing--xs":"Loading_spacing--xs__f8_dP","spacing--sm":"Loading_spacing--sm__BQT8f","spacing--md":"Loading_spacing--md__wjnkH","spacing--lg":"Loading_spacing--lg__vQy0F","spacing--xl":"Loading_spacing--xl__4069e","spacing--xxl":"Loading_spacing--xxl__MMJcu","spacing--xxxl":"Loading_spacing--xxxl__uHHvb","container":"Loading_container__gSMkV","fadeInItems":"Loading_fadeInItems__IBCzh"};

/***/ }),

/***/ 7764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SliderCover_spacing--xxxs__iTqjK","spacing--xxs":"SliderCover_spacing--xxs__egwaf","spacing--xs":"SliderCover_spacing--xs__SOxLb","spacing--sm":"SliderCover_spacing--sm__SX4yx","spacing--md":"SliderCover_spacing--md__3HmPV","spacing--lg":"SliderCover_spacing--lg__DhAWQ","spacing--xl":"SliderCover_spacing--xl__0HHQy","spacing--xxl":"SliderCover_spacing--xxl__3jSb0","spacing--xxxl":"SliderCover_spacing--xxxl__0Y4_u","container":"SliderCover_container__d975A","media":"SliderCover_media__JFSSf","mediaMobile":"SliderCover_mediaMobile__IwxPg","mediaDesktop":"SliderCover_mediaDesktop__FXPIt","link":"SliderCover_link__TJc_r","info":"SliderCover_info__MYH7r","mainTitleContainer":"SliderCover_mainTitleContainer__IBGLI","mainTitle":"SliderCover_mainTitle__FXnyj","title":"SliderCover_title__p3AWD","description":"SliderCover_description__Msijt","progressBar":"SliderCover_progressBar__PNbyG","progressBarIndicator":"SliderCover_progressBarIndicator__RWFiS","fadeInItems":"SliderCover_fadeInItems__T0O7m"};

/***/ }),

/***/ 377:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SplashText_spacing--xxxs__DPfYp","spacing--xxs":"SplashText_spacing--xxs___hYMN","spacing--xs":"SplashText_spacing--xs__QXphm","spacing--sm":"SplashText_spacing--sm__hLeU_","spacing--md":"SplashText_spacing--md__ZG3BJ","spacing--lg":"SplashText_spacing--lg__I4S4A","spacing--xl":"SplashText_spacing--xl__EPdc9","spacing--xxl":"SplashText_spacing--xxl__vn8Jn","spacing--xxxl":"SplashText_spacing--xxxl__I8t2_","container":"SplashText_container__jrqhb","containerActive":"SplashText_containerActive__jYsL1","row":"SplashText_row__bBqjd","text":"SplashText_text__ulf_N","textActive":"SplashText_textActive__dMBsy","fadeInItems":"SplashText_fadeInItems__79LfW","scrollLeft":"SplashText_scrollLeft__F3IKn","scrollRight":"SplashText_scrollRight__meaA1"};

/***/ }),

/***/ 8735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Title_spacing--xxxs__sEhJq","spacing--xxs":"Title_spacing--xxs__DgJXk","spacing--xs":"Title_spacing--xs__DA8px","spacing--sm":"Title_spacing--sm__AvCBI","spacing--md":"Title_spacing--md__n1H3y","spacing--lg":"Title_spacing--lg___qrsK","spacing--xl":"Title_spacing--xl__7hIyQ","spacing--xxl":"Title_spacing--xxl__Eoec_","spacing--xxxl":"Title_spacing--xxxl__0Xl1t","container":"Title_container__5MuPN","swapColour":"Title_swapColour__Csfih","subtitle":"Title_subtitle__t4Jhl","lightUi":"Title_lightUi__owagC","borderTitle":"Title_borderTitle__opYdU","subtitleLong":"Title_subtitleLong__7K7dp","lightSubtitle":"Title_lightSubtitle__iCTJ6","fadeInItems":"Title_fadeInItems___Zi_4"};

/***/ }),

/***/ 1331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"_site__spacing--xxxs__Kp_gk","spacing--xxs":"_site__spacing--xxs__7IyYG","spacing--xs":"_site__spacing--xs__rEifp","spacing--sm":"_site__spacing--sm__5nQIr","spacing--md":"_site__spacing--md__FROMz","spacing--lg":"_site__spacing--lg__nlLGi","spacing--xl":"_site__spacing--xl__uHzin","spacing--xxl":"_site__spacing--xxl___ZqNv","spacing--xxxl":"_site__spacing--xxxl__kk_HN","container":"_site__container__oG5VE","logo":"_site__logo__szSdH","locations":"_site__locations__VN4DC","location":"_site__location__8v_vo","noItems":"_site__noItems__NWHEJ","fadeInItems":"_site__fadeInItems__nNNHY"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,66,529,598,895,774,888,179], function() { return __webpack_exec__(2963); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);